export const environment = {
  production: false,
  url: 'https://api.collaborators.people.uat.private.unico.run/api/v1',
  url_onboarding: 'https://admin.rh.homolog.acesso.io/svc2',
  cdn_url: 'https://admin.rh.homolog.acesso.io/cdn2',
  identity_url: 'https://identityhomolog.acesso.io',
  base_url: 'https://admin.rh.homolog.acesso.io/',
  sign_url: 'https://sign-core-uat.acesso.io',
  sign_id: 'DB8EF2DD966F2CE9F3237F1A1746143B346393D373C7268FFC32759DE06597EA',
  segment_key: 'aJSx6ITwDTBcFEq6je022Y0UrC52Khm1',
  redirect_uri: 'https://collaborators.rh.homolog.acesso.io/preauthorize',
  base_ongoing_url: 'https://collaborators.rh.homolog.acesso.io',
  base_sign_url: 'https://sign-uat.acesso.io/bff/v1',
  sentry_key: 'N/A',
  launchDarklyClientId: '63b870113b5a4212abb0f0fa',
  mixpanel_token: 'f4069d9b550ea08e34089810c2abd5be',
};
